import { useSidePopout } from 'modules/layout';
import { Button, ButtonType } from 'modules/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ForgottenPasswordForm } from '../../forgottenPassword';
import { ContactPathsEnum } from '../../../../contactPage/routes';
import { FooterButtonsWrapper } from './styled';

export const FooterButtons: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { changePopoutContainer, closePopout } = useSidePopout();

  const redirectToContactForm = () => {
    closePopout();
    history.push({
      pathname: ContactPathsEnum.contactPage,
    });
  };

  return (
    <FooterButtonsWrapper>
      <Button
        type={ButtonType.Text}
        text={t('landingPage.loginForm.forgottenPassword')}
        onClick={() =>
          changePopoutContainer({
            newContainer: <ForgottenPasswordForm />,
            urlKey: 'fyp',
          })
        }
        ariaLabel={t('landingPage.loginForm.forgottenPassword')}
      />
      <Button
        type={ButtonType.Text}
        text={t('landingPage.loginForm.initialPasswordSetup')}
        onClick={() =>
          changePopoutContainer({
            newContainer: <ForgottenPasswordForm />,
            urlKey: 'fyp',
          })
        }
        ariaLabel={t('landingPage.loginForm.initialPasswordSetup')}
      />
      <Button
        type={ButtonType.Text}
        text={t('landingPage.loginForm.customerSupport')}
        onClick={redirectToContactForm}
        ariaLabel={t('landingPage.loginForm.customerSupport')}
      />
      <Button
        type={ButtonType.Text}
        text={t('landingPage.loginForm.userGuide')}
        onClick={() =>
          window.open('https://unicreditleasing.hr/home/podrska', '_blank')
        }
        ariaLabel={t('landingPage.loginForm.userGuide')}
      />
    </FooterButtonsWrapper>
  );
};
